import { type ComponentType, type FC } from 'react';
import { type ResponsiveContextModalProps } from '~/shared/ui/ResponsiveModals';

export const withResponsiveModalProps = <P extends object>(
    Component: ComponentType<P>,
): FC<ResponsiveContextModalProps<object>> => {
    return ({ context, id, innerProps }: ResponsiveContextModalProps<object>) => {
        const componentProps = {
            ...innerProps,
            onClose: () => context.closeModal(id),
            onTitleChange: (_mode: unknown, title: string) => {
                context.updateModal({
                    innerProps,
                    modalId: id,
                    title,
                });
            },
        } as P;

        return <Component {...componentProps} />;
    };
};
